var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg38(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7344 16.6602C36.8164 16.1133 35.6055 16.1133 34.5898 16.6602L27.4023 20.8203L22.5195 23.5352L15.332 27.6953C14.4141 28.2422 13.2031 28.2422 12.1875 27.6953L6.46484 24.4336C5.54687 23.8867 4.90234 22.8906 4.90234 21.7969V15.3906C4.90234 14.2969 5.44922 13.3008 6.46484 12.7539L12.0898 9.58984C13.0078 9.04297 14.2188 9.04297 15.2344 9.58984L20.8594 12.7539C21.7773 13.3008 22.4219 14.2969 22.4219 15.3906V19.5508L27.3047 16.7383V12.5781C27.3047 11.4844 26.7578 10.4883 25.7422 9.94141L15.3125 3.98437C14.3945 3.4375 13.1836 3.4375 12.168 3.98437L1.5625 9.96094C0.546875 10.5078 0 11.5039 0 12.5977V24.6484C0 25.7422 0.546875 26.7383 1.5625 27.2852L12.168 33.2617C13.0859 33.8086 14.2969 33.8086 15.3125 33.2617L22.5 29.1797L27.3828 26.3672L34.5703 22.2852C35.4883 21.7383 36.6992 21.7383 37.7148 22.2852L43.3398 25.4492C44.2578 25.9961 44.9023 26.9922 44.9023 28.0859V34.5117C44.9023 35.6055 44.3555 36.6016 43.3398 37.1484L37.7148 40.4102C36.7969 40.957 35.5859 40.957 34.5703 40.4102L28.9453 37.2461C28.0273 36.6992 27.3828 35.7031 27.3828 34.6094V30.4492L22.5 33.2617V37.4219C22.5 38.5156 23.0469 39.5117 24.0625 40.0586L34.668 46.0352C35.5859 46.582 36.7969 46.582 37.8125 46.0352L48.4375 40.0391C49.3555 39.4922 50 38.4961 50 37.4023V25.3516C50 24.2578 49.4531 23.2617 48.4375 22.7148L37.7344 16.6602Z",
    fill: "#8247E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 37.9687L42.3437 42.4219V25.4883L34.6875 37.9687Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 25.4883V42.4219L50 37.9687L42.3438 25.4883Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 34.5508L50 37.9688L42.3438 42.4219V34.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3437 34.5508V42.4219L34.6875 37.9688L42.3437 34.5508Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 39.3945L42.3437 50V43.8477L34.6875 39.3945Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 43.8477V50L50 39.3945L42.3438 43.8477Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg38);
export default __webpack_public_path__ + "static/media/38.646a0c3d3a1eb5b1c29e479d021e4309.svg";
export { ForwardRef as ReactComponent };